export default "__VITE_ASSET__bt6DtBg8__"